import { AppConfigService, AppConfigProvider, HttpService } from '@lk/api'

const defaults = {
  maxAllowedTimeDifferenceWithServer: 60 * 1440, // 1440 min = 60 x 24 hours
  requiredFields: {},
  shouldCheckHypothecAreasSum: false,
}

// const mergeString = (defaultValue, configValue) => configValue || defaultValue

const customizers = {
  // someKey: mergeString,
}

export const makeAppConfigService = (http: HttpService) =>
  new AppConfigService(defaults, customizers, new AppConfigProvider(http))
